<template><div><h1 id="buchungstexte" tabindex="-1"><a class="header-anchor" href="#buchungstexte"><span>Buchungstexte</span></a></h1>
<p>Buchungstexte — Definition eigener Buchungstexte</p>
<h2 id="beschreibung" tabindex="-1"><a class="header-anchor" href="#beschreibung"><span>Beschreibung</span></a></h2>
<p>Die im System möglichen Buchungstypen sind fest vorgegeben. In der Tabelle Buchungstexte können die an die Finanzbuchhaltung zu übergebenden Buchungstexte sowie die zu bebuchende Kombination Kto/Kst/Ktr bestimmt werden. Sie sind aber lediglich Vorschlagswerte, die übersteuert werden können, d.h. sie dienen als Reserveinformation, wenn andere Quellen nicht angegeben sind bzw. im Falle von manuellen Buchungen als Vorschlagswert. Bei der Übergabe der Buchhaltungsdaten an die Schnittstelle zur Finanzbuchhaltung (Aggregierte Buchungen) handelt es sich um pro Kombination Kto/Kst/Ktr summierte Werte aus den Einzelbuchungen.</p>
<p>Pfad: <code v-pre>Buchhaltung → Tabellen → Buchungstexte</code></p>
<h2 id="datenfelder" tabindex="-1"><a class="header-anchor" href="#datenfelder"><span>Datenfelder</span></a></h2>
<dl>
<dt>Typ</dt>
<dd>Buchungstyp</dd>
<dt>Bezeichnung</dt>
<dd>Bezeichnung des Buchungstyps</dd>
<dt>Buchungstext</dt>
<dd>Buchungstext, der in der Finanzbuchhaltung erscheint</dd>
<dt>Sammelkonto</dt>
<dd>Sammelkonto, wenn im System sonst kein Konto für die Buchung angegeben wurde. Siehe oben in der Beschreibung</dd>
<dt>Kostenstelle</dt>
<dd>Kostenstelle, siehe oben in der Beschreibung</dd>
<dt>Kostenträger</dt>
<dd>Kostenträger, siehe oben in der Beschreibung</dd>
</dl>
<h2 id="funktionen" tabindex="-1"><a class="header-anchor" href="#funktionen"><span>Funktionen</span></a></h2>
<h2 id="siehe-auch" tabindex="-1"><a class="header-anchor" href="#siehe-auch"><span>Siehe auch</span></a></h2>
<p><RouteLink to="/manual/buchhaltung/debitorenverwaltung.html" title="Kapitel 6. Buchhaltung">Buchhaltung</RouteLink></p>
</div></template>


